import React from "react";
import { Object3D, MathUtils} from "three";

export enum Mode {
    None,
    Translate,
    Rotate,
    Orient,
    Snap,
    FaceUpOrient,
    MoveToCentre,
    Scale,
}

export interface ICoordinateEntry {
  name: string;
  currentValue: number;
  onChange: (arg0: number) => void;
  inputDom: HTMLInputElement | null;
  inputRefCallback: React.RefCallback<HTMLInputElement>;
}
interface IProps {
  mesh: Object3D;
  mode: Mode;
  updater: () => void;
  refreshToken: boolean;
}
export function truncated(num, decimalPlaces) {
  const numPowerConverter = Math.pow(10, decimalPlaces);
  return Math.round(num * numPowerConverter) / numPowerConverter;
}

export const CoordinateDisplay: React.FunctionComponent<IProps> = (props) => {
  let [coordinateSet, changeCoordinateSet] = React.useState<ICoordinateEntry[]>(
    []
  );
  React.useEffect(() => {
    switch (props.mode) {
      case Mode.Translate:
        coordinateSet = ["x", "y", "z"].map(
          (coord, index): ICoordinateEntry => {
            return Object({
              name: coord,
              currentValue: truncated(props.mesh.position[coord], 2),
              onChange: (value: number) => {
                props.mesh.position[coord] = value;
                props.updater();
                coordinateSet[index].currentValue = value
              },
              inputDom: null,
              inputRefCallback: (el) => (coordinateSet[index].inputDom = el),
            });
          }
        );
        changeCoordinateSet(coordinateSet);
        break;
      case Mode.Rotate:
      case Mode.Orient:
        coordinateSet = ["x", "y", "z"].map((coord, index): ICoordinateEntry => {
          return Object(
            {
              name: coord,
              currentValue: truncated(MathUtils.radToDeg(props.mesh.rotation[coord]), 2),
              onChange: (value: number) => {
                props.mesh.rotation[coord] = MathUtils.degToRad(value);
                props.updater();
              },
              inputDom: null,
              inputRefCallback: (el) => (coordinateSet[index].inputDom = el),
            })
        })
        changeCoordinateSet(coordinateSet);
        break;
    }
    //  }, [props.mode, JSON.stringify(props.mesh.rotation), JSON.stringify(props.mesh.position)]);
  }, [props.mode, JSON.stringify(props.mesh.rotation), JSON.stringify(props.mesh.position)]);

  React.useEffect(() => {
    let propertyName = props.mode === Mode.Translate ? "position" : "rotation";
    for (let coordinateEntry of coordinateSet) {
      let coordinateValue = props.mesh[propertyName][coordinateEntry.name];
      if (props.mode === Mode.Rotate || props.mode === Mode.Orient) {
        coordinateValue = MathUtils.radToDeg(coordinateValue);
      }
      coordinateValue = truncated(coordinateValue, 2)
      let input = coordinateEntry.inputDom;
      if (input) {
        input!.value = coordinateValue;
      } else {
        coordinateEntry.inputRefCallback = (el) => {
          if (el) {
            coordinateEntry.inputDom = el;
            el.value = coordinateValue;
          }
        };
      }
    }
    //  }, [props.refreshToken, props.mode, JSON.stringify(props.mesh.rotation), JSON.stringify(props.mesh.position)]);
  }, [props.refreshToken, props.mode, JSON.stringify(props.mesh.rotation), JSON.stringify(props.mesh.position)]);

  return (
    <div style={{ position: "absolute", top: 60, left: 75 }}>
      <div style={{ border: "solid", backgroundColor: "white" }}>
        <ul>
          {coordinateSet.map((coordinateEntry, i) => (
            <div key={i} style={{ marginLeft: 5 }}>
              {coordinateEntry.name.toUpperCase()}:
              <input
                type="number"
                ref={coordinateEntry.inputRefCallback}
                style={{ width: 100, marginLeft: 5 }}
                defaultValue={coordinateEntry.currentValue}
                step={0.1}
                onChange={(ev) => {
                  let number = parseFloat((ev.target as any).value);
                  if (!Number.isNaN(number)) {
                    coordinateEntry.onChange(number);
                  }
                }}
              />
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};
